/** Only safe reads are eligible; mutation retries need explicit idempotency. */
export function quotaRetryDelay(method: string | undefined, attempt: number, header: unknown, now = Date.now()): number | null {
  if (!["get", "head"].includes((method || "get").toLowerCase()) || attempt >= 2) return null;
  if (typeof header !== "string" && typeof header !== "number") return null;
  const text = String(header).trim();
  if (!text) return null;
  const delay = /^\d+(\.\d+)?$/.test(text) ? Number(text) * 1000 : Date.parse(text) - now;
  return Number.isFinite(delay) && delay >= 0 && delay <= 120000 ? delay + 250 : null;
}
